<script>
import { mapActions, mapGetters } from "vuex";
// import store from "@/state/store";
import {
  required,
  //   between,
  numeric,
  // requiredIf,
} from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import VueCountryCode from "vue-country-code";
import Api from "../../../services/integrationApi";
import CustomStore from "devextreme/data/custom_store";
// import store from "@/state/store";

import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import PageHeader from "@/components/page-header";
// import DataTable from "@/components/grid/DataTable";
// import EditIntegModal from "@/components/integration/EditIntegrationModal";
// import SyncIntegModal from "@/components/integration/SyncIntegrationModal";
import { default as Button } from "devextreme-vue/button";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { exportDataGrid as exportDataGridToPdf } from "devextreme/pdf_exporter";
import "whatwg-fetch";
const dataGridRef = "dataGrid";
import DxDataGrid, {
  DxColumn,
  // DxLookup,
  DxFilterRow,
  DxHeaderFilter,
  // DxSearchPanel,
  DxColumnChooser,
  DxExport,
  DxToolbar,
  DxItem,
  DxPaging,
  DxPager,
  // DxGrouping,
  // DxGroupPanel,
  DxScrolling,
} from "devextreme-vue/data-grid";
function isNotEmpty(value) {
  return value !== undefined && value !== null && value !== "";
}
export default {
  components: {
    Breadcrumb,
    PageHeader,
    // EditIntegModal,
    // DataTable,
    // SyncIntegModal,
    DxDataGrid,
    DxColumn,
    // DxLookup,
    DxFilterRow,
    DxHeaderFilter,
    DxPaging,
    DxPager,
    // DxSearchPanel,
    DxColumnChooser,
    DxExport,
    DxToolbar,
    DxItem,
    Multiselect,
    VueCountryCode,
    Button,
    DxDropDownButton,
    DxScrolling,
  },
  data() {
    return {
      rtlEnabled: false,
      nextLoading: false,
      showClearAll: false,
      multipleFilters: [],
      userTypeHeaderFilter: [],
      totalCount: 0,
      sortObject: 0,
      finalFilterObject: 0,
      user_type_id: "",
      buttonData: ["Excel", "CSV", "PDF"],
      dataGridRef,
      title: this.$t("sideNavbarMenu.integration.text"),
      isLoading: false,
      update: true,
      intdropdown_closed: true,
      submitted: false,
      userPhone: null,
      currentPhone: false,
      userCountryCode: null,
      form: {
        user: {
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          image: null,
          user_type_id: null,
          rfid_number: null,
          user_user_id: null,
          //   system_user: false,
          department_id: null,
          role_id: null,
        },
        entity: {
          entity_id: null,
        },
      },
      items: [
        {
          text: this.$t("sideNavbarMenu.integration.text"),
          to: { name: "addIntegration" },
        },
      ],
      dataStore: new CustomStore({
        key: "id",
        load: (loadOptions) => {
          console.log("load fn from custom store fired");
          let params = "?";
          let filterQuery = "";
          console.log("filterQuery", filterQuery);
          let sortObject = { sortField: null, sortOrder: "" };
          [
            "skip",
            "take",
            "requireTotalCount",
            "requireGroupCount",
            "sort",
            "filter",
            "totalSummary",
            "group",
            "groupSummary",
          ].forEach((i) => {
            console.log("forEach", i, loadOptions[i]);
            console.log("isnotempty", isNotEmpty(loadOptions[i]));
            if (i in loadOptions && isNotEmpty(loadOptions[i])) {
              params += `${i}=${JSON.stringify(loadOptions[i])}&`;
              if (i == "filter") {
                console.log("loadOptions[i]", loadOptions[i]);
                filterQuery += `${JSON.stringify(loadOptions[i])}`;
              }
              if (i == "sort") {
                sortObject.sortField = loadOptions[i][0].selector;
                sortObject.sortOrder = loadOptions[i][0].desc ? "desc" : "asc";
              }
            }
          });
          // this.resetUsersData();
          console.log("1 params", params);
          params = params.slice(0, -1);
          console.log("2 params", params);
          let filters;
          let finalFilterObject = {};
          this.multipleFilters = [];
          if (filterQuery) filters = JSON.parse(filterQuery);
          if (filters) console.log("filters", filters);
          if (filters && typeof filters[0] === "string") {
            if (filters[0] == "!") {
              console.log("not");
              if (typeof filters[1] === "object") {
                const excludeIds = [];
                const columnHeader =
                  typeof filters[1][0] === "object"
                    ? filters[1][0][0] + "HeaderFilter"
                    : filters[1][0] + "HeaderFilter";
                const columnHeaderFilter =
                  columnHeader.charAt(0).toLowerCase() + columnHeader.slice(1);
                console.log(columnHeaderFilter); // name of column filter
                if (typeof filters[1][0] === "object") {
                  console.log("obj");
                  filters[1].map((item) => {
                    if (typeof item === "object") {
                      console.log("item", item[2][0]);
                      excludeIds.push(item[2][0]);
                    }
                  });
                } else {
                  console.log("else");
                  // filters[1].map(item => {
                  // if (typeof item === "object") {
                  console.log("item", filters[1][2][0]);
                  excludeIds.push(filters[1][2][0]);
                  // }
                  // });
                }
                console.log(this[columnHeaderFilter]);
                const arr = this[columnHeaderFilter].filter(
                  (el) => !excludeIds.includes(el.value[2][0])
                );
                console.log("arr", arr, excludeIds);
                if (typeof filters[1][0] === "object") {
                  finalFilterObject[filters[1][0][0]] = arr.map((item) => {
                    return item.value[2][0];
                  });
                } else {
                  finalFilterObject[filters[1][0]] = arr.map((item) => {
                    return item.value[2][0];
                  });
                }
                console.log("finalFilterObject", finalFilterObject);
                // if (this.multipleFilters.length > 0) {
                this.multipleFilters.push(finalFilterObject);
                // }
              }
            } else {
              finalFilterObject[filters[0]] =
                filters[1] === "contains" || filters[1] === "="
                  ? filters[2]
                  : filters[2];
            }

            // if (this.multipleFilters.length > 0) {
            this.multipleFilters.push(finalFilterObject);
            // }
          } else {
            // const isOr = filters[1] === 'or';
            // const isAnd = filters[1] === 'and';
            if (filters)
              for (const filter of filters) {
                if (filter[0] == "!") {
                  // console.log('multiple filters not');
                  if (typeof filter[1] === "object") {
                    const excludeIds = [];
                    const columnHeader =
                      typeof filter[1][0] === "object"
                        ? filter[1][0][0] + "HeaderFilter"
                        : filter[1][0] + "HeaderFilter";
                    const columnHeaderFilter =
                      columnHeader.charAt(0).toLowerCase() +
                      columnHeader.slice(1);
                    console.log(columnHeaderFilter); // name of column filter
                    if (typeof filter[1][0] === "object") {
                      // console.log('obj');
                      filter[1].map((item) => {
                        if (typeof item === "object") {
                          // console.log('item', item[2][0]);
                          excludeIds.push(item[2][0]);
                        }
                      });
                    } else {
                      // console.log('else');
                      // filters[1].map(item => {
                      // if (typeof item === "object") {
                      // console.log('item', filter[1][2][0]);
                      excludeIds.push(filter[1][2][0]);
                      // }
                      // });
                    }
                    // console.log(this[columnHeaderFilter]);
                    const arr = this[columnHeaderFilter].filter(
                      (el) => !excludeIds.includes(el.value[2][0])
                    );
                    // console.log('arr', arr, excludeIds);
                    if (typeof filter[1][0] === "object") {
                      finalFilterObject[filter[1][0][0]] = arr.map((item) => {
                        return item.value[2][0];
                      });
                    } else {
                      finalFilterObject[filter[1][0]] = arr.map((item) => {
                        return item.value[2][0];
                      });
                    }
                    console.log("finalFilterObject", finalFilterObject);
                    this.multipleFilters.push(finalFilterObject);
                  }
                }
                let orExist;
                let andExist;
                if (typeof filter === "object") {
                  console.log("obj", filter);
                  orExist = filter.find((item) => item === "or");
                  andExist = filter.find((item) => item === "and");
                  if (filter[1] == "or") {
                    // Header Filter - Gather In One Condition
                    if (
                      filter[0][1] === ">=" ||
                      filter[0][1] === "<=" ||
                      filter[0][1] === "<"
                    ) {
                      const finalFilter = {};
                      const condition = [];
                      for (const filterItem of filter) {
                        if (filterItem[2]) condition.push(filterItem[2][0]);
                      }
                      finalFilter[filter[0][0]] = {
                        start: condition[0].replace(/\//g, "-"),
                        end: condition[1].replace(/\//g, "-"),
                      };
                      this.multipleFilters.push(finalFilter);
                    } else {
                      // Gather In One Condition
                      for (const filter of filter) {
                        if (filter[1] === "contains" || filter[1] === "=") {
                          const finalFilter = {};
                          finalFilter[filter[0]] =
                            filter[1] === "contains" || filter[1] === "="
                              ? filter[2]
                              : filter[2];

                          // Header Filter - Gather In One Condition
                          const filterExist = this.multipleFilters.find(
                            (item) => item[filter[0]]
                          );
                          if (!filterExist)
                            this.multipleFilters.push(finalFilter);
                          else filterExist[filter[0]].push(filter[2][0]);
                        }
                      }
                    }
                  } // -------------- Header Filter --------------------
                }
                if (
                  filter.length > 0 &&
                  filter[0] &&
                  filter[0] !== "Actions" &&
                  !orExist &&
                  !andExist
                ) {
                  if (filter[1] === "contains" || filter[1] === "=") {
                    const finalFilter = {};
                    finalFilter[filter[0]] =
                      filter[1] === "contains" || filter[1] === "="
                        ? filter[2]
                        : filter[2];

                    // Header Filter - Gather In One Condition
                    const filterExist = this.multipleFilters.find(
                      (item) => item[filter[0]]
                    );
                    if (!filterExist) this.multipleFilters.push(finalFilter);
                    else filterExist[filter[0]].push(filter[2][0]);
                  }
                } else if (andExist) {
                  for (const andFilter of filter) {
                    if (
                      andFilter.length > 0 &&
                      andFilter[0] &&
                      andFilter[0] !== "Actions"
                    ) {
                      if (andFilter[1] === "contains" || andFilter[1] === "=") {
                        const finalFilter = {};
                        finalFilter[andFilter[0]] =
                          andFilter[1] === "contains" || andFilter[1] === "="
                            ? andFilter[2]
                            : andFilter[2];
                        this.multipleFilters.push(finalFilter);
                      }
                    }
                  }
                }
              }
          }

          finalFilterObject =
            this.multipleFilters && this.multipleFilters.length > 0
              ? Object.assign({}, ...this.multipleFilters)
              : finalFilterObject;

          this.filterExportObject = finalFilterObject;
          this.sortExportObject = sortObject;

          console.log(
            "fffff",
            finalFilterObject,
            JSON.stringify(finalFilterObject)
          );

          let queryParams = {
            filterBy: finalFilterObject,
            orderBy: sortObject ? sortObject : { sortField: null },
          };

          if (this.isExport) {
            queryParams.isExporting = true;
          }
          this.isLoading = true;
          return Api()
            .get(
              `/integration/${this.getIntegId}/tempUsers/error/${this.userDetails.id}/${this.currentEntity.owner_id}${params}`,
              {
                params: queryParams,
              }
            )
            .then((data) => {
              const dataArr = [];
              data.data.map((user) => {
                dataArr.push({
                  dir_int_id: user.dir_int_id,
                  email: user.email,
                  first_name: user.first_name,
                  last_name: user.last_name,
                  phone: user.phone,
                  id: user.id,
                  rfid_number: user.rfid_number,
                  user_id: user.user_id,
                  user_type: user.user_type
                    ? Object.values(JSON.parse(user.user_type))[0]
                    : "-",
                  userType: user.user_type ? JSON.parse(user.user_type) : "",
                  //   user_type_id: Object.keys(JSON.parse(user.user_type))[0],
                  requiredError: JSON.parse(user.errors).error.required,
                  invalidError: JSON.parse(user.errors).error.invalid,
                  userTypeError: JSON.parse(user.errors).error.user_type
                    ? Object.values(
                        JSON.parse(user.errors).error.user_type
                      ).join("\r& Group ")
                    : "",
                  errors: JSON.parse(user.errors),
                  auto: user.auto,
                  duplicate_status: user.duplicate_status,
                });
              });

              // this.isServerSideExport = data.data.totalCount >= process.env.VUE_APP_EXPORT_LIST_COUNT;
              this.finalFilterObject = finalFilterObject;
              this.sortObject = sortObject ? sortObject : { sortField: null };
              this.isLoading = false;
              this.$store.commit(
                "integration/setUsersWithErrsCount",
                data.totalCount
              );
              return {
                data: dataArr,
                totalCount: data.totalCount,
                summary: data.summary,
                groupCount: data.data.length,
              };
            })
            .catch((err) => {
              throw new Error(err);
            });
        },
        // eslint-disable-next-line no-unused-vars
      }),
    };
  },

  validations: {
    form: {
      user: {
        first_name: { required },
        last_name: { required },
        // email: {
        //   required: requiredIf(function () {
        //     const {
        //       form: {
        //         user: { phone },
        //       },
        //     } = this;
        //     return !phone;
        //   }),
        // },
        phone: {},
        user_user_id: { required },
      },
    },
    userPhone: {
      // required: requiredIf(function () {
      //   const {
      //     form: {
      //       user: { email, phone },
      //     },
      //   } = this;
      //   return !email && !phone;
      // }),
      numeric,
    },
  },

  methods: {
    ...mapActions("dailyLogbook", ["fetchUserTypes"]),
    ...mapActions("integration", [
      "fetchTempUsersWithErrors",
      "fixTempUsersWithErrors",
      "redirectType",
      "redirectToIntegrationSettings",
      "awaitIntegrationWithMapping",
      "fetchIntegrationUsersTypes",
    ]),
    ...mapActions("modal", ["onResetModal", "setData"]),
    // ...mapActions("userType", ["fetchAllUserType"]),
    // ...mapActions("users", ["updateUserAction"]),

    // ...mapActions("integration", ["StartSyncUsers"]),

    onEditorPreparing(e) {
      if (e.parentType == "filterRow") {
        e.editorOptions.placeholder = this.$t("common.grid.search");
      }
    },

    getErrMsg(rowData) {
      // console.log('rowdata', rowData);
      let str = "";
      if (rowData.requiredError)
        rowData.requiredError.map(
          (item, index) =>
            (str += ` ${
              item == "first_name"
                ? "First Name"
                : item == "last_name"
                ? "Last Name"
                : item
            } is required ${
              rowData.requiredError[index + 1] ||
              (rowData.invalidError && rowData.invalidError.length > 0) ||
              ((!rowData.invalidError || rowData.invalidError.length == 0) &&
                rowData.userTypeError)
                ? "/ "
                : ""
            }`)
        );

      if (rowData.invalidError)
        rowData.invalidError.map(
          (item, index) =>
            (str += `Invalid ${item == "email" ? "email address" : item} ${
              rowData.invalidError[index + 1] || rowData.userTypeError
                ? " / "
                : ""
            }`)
        );

      if (rowData.userTypeError)
        str += ` User is assigned to Group ${rowData.userTypeError}`;
      // console.log('str', str);
      return str;
    },

    setResetModal() {
      this.$bvModal.hide("add-edit-user");
    },

    hideModalTrigger() {
      this.setData(null);
    },

    openEditUserModal(data) {
      //   this.setData({});
      console.log("modal", data);
      this.userPhone = null;
      this.form.user = JSON.parse(JSON.stringify(data));
      this.user_type_id = {
        id: Object.keys(data.userType)[0],
        name: Object.values(data.userType)[0],
      };
      //   this.form.user.first_name = data.firstName;
      //   this.form.user.last_name = data.lastName;
      //   this.form.user.email = data.emailAddress;
      //   this.form.user.phone = data.phoneNumber;
      this.form.user.user_user_id = data.id;
      //   this.form.user.rfid_number = data.RFID;
      //   console.log(this.form.user);
      this.currentPhone = data.phone ? true : false;
      this.$bvModal.show("add-edit-user");
    },

    generateUserID() {
      let length = 8,
        charset =
          "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
      let i = 0,
        n = charset.length;
      for (; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      this.form.user.user_user_id = "VP-" + retVal;
    },

    onItemClick(e) {
      if (e.itemData == "Excel") {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");
        exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          customizeCell: function (options) {
            const excelCell = options;
            excelCell.font = { name: "Arial", size: 12 };
            excelCell.alignment = { horizontal: "left" };
          },
        }).then(function () {
          workbook.xlsx.writeBuffer().then(function (buffer) {
            saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              "Errors.xlsx"
            );
          });
        });
        // e.cancel = true;
      } else if (e.itemData == "CSV") {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");

        exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          customizeCell: function (options) {
            const excelCell = options;
            excelCell.font = { name: "Arial", size: 12 };
            excelCell.alignment = { horizontal: "left" };
          },
        }).then(function () {
          workbook.csv.writeBuffer().then(function (buffer) {
            saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              "Errors.csv"
            );
          });
        });
      } else if (e.itemData == "PDF") {
        const doc = new jsPDF("landscape");
        // settings.SettingsExport.Landscape = true;
        exportDataGridToPdf({
          jsPDFDocument: doc,
          component: this.dataGrid,
        }).then(() => {
          doc.save("Errors.pdf");
        });
      }
    },

    clearFilter() {
      this.dataGrid.clearFilter("row");
      this.dataGrid.clearFilter("header");
      this.dataGrid.clearSorting();
      this.showClearAll = false;
    },

    contentReady(e) {
      let sortedExp = this.getSortedColumns();
      let filterExp = e.component.getCombinedFilter();
      if (filterExp || sortedExp) {
        this.showClearAll = true;
      } else {
        this.showClearAll = false;
      }
      this.setColumnChooserPosition();
    },

    getSortedColumns() {
      let allColumns = Array.from(
        Array(this.dataGrid.columnCount()).keys()
      ).map((index) => this.dataGrid.columnOption(index));
      allColumns = allColumns.find((col) => col.sortIndex != null);
      return allColumns;
    },

    setColumnChooserPosition() {
      // this.dataGrid.showColumnChooser();
      // console.log("columnChooserView");

      var columnChooserView = this.dataGrid.getView("columnChooserView");

      if (!columnChooserView._popupContainer) {
        columnChooserView._initializePopupContainer();
        columnChooserView.render();
      }

      columnChooserView._popupContainer.option("position", {
        of: this.dataGrid.element(),
        my: this.rtlEnabled ? "right top" : "left top",
        at: this.rtlEnabled ? "right top" : "left top",
        offset: "0 50",
      });
    },

    onSubmit() {
      this.submitted = true;
      this.$v.$touch();
      this.$v.$error ? "" : this.submission();
    },

    submission() {
      const { fixTempUsersWithErrors } = this;
      const data = this.form.user;
      if (this.userPhone)
        this.form.user.phone = `${this.userCountryCode}${this.userPhone}`;
      data.phone = this.form.user.phone;
      const userTypeId = {};
      userTypeId[this.user_type_id.id] = this.user_type_id.name;
      // data.user_type = JSON.stringify(this.form.user.user_type);
      console.log("submit", data, userTypeId, JSON.stringify(userTypeId));
      data.user_type = JSON.stringify(userTypeId);
      fixTempUsersWithErrors({ id: data.user_id, user: data }).then((data) => {
        if (data.is_already_fixed) {
          this.$bvModal.show("alreadyFixedErr");
        }
        this.dataGrid.refresh();
      });
      // console.log("count", this.getUsersWithErrsCount);
      // this.$bvModal.hide("add-edit-user");
    },

    onSelectUserCountryCode({ dialCode }) {
      this.userCountryCode = dialCode;
    },

    onChangeToUpdatePhone() {
      this.currentPhone = false;
    },

    redirectUser() {
      this.nextLoading = true;
      this.redirectType({ id: this.getIntegId });
    },

    redirectUserToIntegrationSettings() {
      this.redirectToIntegrationSettings();
    },
  },

  computed: {
    ...mapGetters("i18N", ["getLanguage"]),
    ...mapGetters("dailyLogbook", ["getUserTypes"]),
    ...mapGetters("authfack", ["currentEntity"]),
    ...mapGetters("authfack", ["userDetails"]),
    ...mapGetters("integration", [
      "getLoading",
      "getModalState",
      "getFromView",
      //   "getSyncStatusText",
      //   "getSyncStatusStage",
      //   "getSyncStatusmsg",
      //   "getValidUsers",
      //   "getValidUsersCount",
      //    "getMigrateStatusText",
      //   "getMigrateStatusStage",
      //   "getMigrateStatusmsg",
      "getIntegId",
      "getIntgDataMapping",
      "getUsersWithErrs",
      "getUsersWithErrsCount",
      "getIntegrationUsersTypes",
    ]),
    ...mapGetters("userType", ["getAllUsersTypes"]),
    // ...mapGetters("users", ["getLoading"]),

    dataGrid() {
      return this.$refs[this.dataGridRef].instance;
    },
    rowsData() {
      console.log(
        "getUsersWithErrs",
        this.getUsersWithErrsCount,
        this.getUsersWithErrs
        // this.getAllUsersTypes
      );
      return this.getUsersWithErrs && this.getUsersWithErrs.length > 0
        ? this.getUsersWithErrs.map((user) => {
            // console.log('errs', JSON.parse(user.errors));
            return {
              dir_int_id: user.dir_int_id,
              email: user.email,
              first_name: user.first_name,
              last_name: user.last_name,
              phone: user.phone,
              id: user.id,
              rfid_number: user.rfid_number,
              user_id: user.user_id,
              userType: user.user_type
                ? Object.values(JSON.parse(user.user_type))[0]
                : "-",
              user_type: user.user_type ? JSON.parse(user.user_type) : "",
              //   user_type_id: Object.keys(JSON.parse(user.user_type))[0],
              requiredError: JSON.parse(user.errors).error.required,
              invalidError: JSON.parse(user.errors).error.invalid,
              userTypeError: JSON.parse(user.errors).error.user_type
                ? Object.values(JSON.parse(user.errors).error.user_type).join(
                    "\r& Group "
                  )
                : "",
              errors: JSON.parse(user.errors),
              auto: user.auto,
              duplicate_status: user.duplicate_status,
            };
          })
        : [];
    },
  },
  beforeMount() {
    if (this.getLanguage == "ar") {
      this.rtlEnabled = true;
    }
    this.fetchUserTypes().then(data => {
      data.data.map((userType) => {
        this.userTypeHeaderFilter.push({
          text: userType.name,
          value: ["user_type", "contains", [userType.id]],
        });
      });
    });
  },
  async mounted() {
    if (this.$route.query.id) {
      this.$store.dispatch("integration/setFromView", true);
      await this.awaitIntegrationWithMapping({ id: this.$route.query.id });
    }
    this.fetchTempUsersWithErrors(this.getIntegId);
    // this.fetchAllUserType();
    this.fetchIntegrationUsersTypes(this.getIntegId);
    // this.getIntegId = 80;
    console.log(
      "mounted count",
      this.getIntegId,
      this.getUsersWithErrs,
      this.getUsersWithErrsCount,
      this.$route.query.id
    );
    // console.log('getintgdata', this.getIntgDataMapping)
    if (this.getIntgDataMapping)
      this.items.push(
        {
          text: this.getIntgDataMapping.name,
          to: {
            name: "viewIntegration",
            params: {
              integId: this.getIntegId,
              integName: this.getIntgDataMapping.name,
            },
          },
          // active: true,
        },
        {
          text: this.$t("integrations.errList"),
          // to: { name: "viewIntegration" },
          active: true,
        }
      );
  },

  destroyed() {
    this.$store.commit("integration/setLoading", false);
  },

  watch: {
    getModalState(state) {
      // deep: true,
      // handle(state) {
      // console.log("watch", state);
      state == true && this.$bvModal.hide("add-edit-user");
    },
    // },
  },

  created() {
    console.log("rowsData", this.rowsData);
    // document.addEventListener("mousedown", (e) => {
    //   if (e.path) {
    //     // console.log("path", e.path);
    //     let isColumnChooser = false;
    //     for (let i = 0; i < e.path.length; i++) {
    //       if (typeof e.path[i].matches == "function") {
    //         if (e.path[i].matches(".dx-overlay-content")) {
    //           isColumnChooser = true;
    //         }
    //       }
    //     }
    //     if (!isColumnChooser) this.dataGrid.hideColumnChooser();
    //   }
    // });
  },
};
</script>

<template>
  <div>
    <!-- already fixed -->
    <b-modal
      id="alreadyFixedErr"
      hide-footer
      size="lg"
      scrollable
      hide-header
      no-close-on-backdrop
    >
      <div>
        <h3 class="signIn-out-header">{{ $t("integrations.errFixed") }}</h3>

        <p class="all-paragraphs">
          {{ $t("integrations.errFixedMsg") }}
        </p>

        <hr />

        <div class="btn-container">
          <button
            class="confirmation-btn"
            @click="$bvModal.hide('alreadyFixedErr')"
          >
            {{ $t("common.okay") }}
          </button>
        </div>
      </div>
    </b-modal>

    <!-- edit user  -->
    <b-modal
      id="add-edit-user"
      class="popover-modal"
      size="md"
      hide-header
      hide-footer
      scrollable
      no-close-on-esc
      ref="add-edit-user"
    >
      <slot name="modal-header">
        <div class="d-flex justify-content-center">
          <h5 class="modal-title">
            <slot name="modal-title">
              <span class="">{{ $t("dashboard.grid.editUser") }}</span>
            </slot>
          </h5>

          <div class="header-close-style d-flex align-items-center">
            <div class="closing-design">
              <svg
                @click="setResetModal"
                style="
                  cursor: pointer;
                  margin-bottom: 58px;
                  margin-top: -8px;
                  margin-inline-end: -8px;
                "
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
                  fill="#F46A6A"
                />
              </svg>
            </div>
          </div>
        </div>
      </slot>
      <b-row class="main-user-form">
        <b-col cols="12">
          <b-row>
            <b-form
              id="form"
              class="form-horizontal"
              @submit.prevent="onSubmit"
            >
              <div class="input-wrapper">
                <div class="form-groups">
                  <!-- user type  -->
                  <div class="user-types-select">
                    <span
                      class="selections-label"
                      v-if="user_type_id && intdropdown_closed"
                    >
                      {{ $t("common.userType") }}
                    </span>
                    <Multiselect
                      id="userType"
                      class="user-types-select"
                      v-model="user_type_id"
                      :options="getIntegrationUsersTypes"
                      :placeholder="$t('common.userType')"
                      :show-labels="false"
                      label="name"
                      :allowEmpty="true"
                      @open="intdropdown_closed = false"
                      @close="intdropdown_closed = true"
                      :class="{
                        'has-error': submitted && !user_type_id,
                      }"
                    >
                      <template slot="option" slot-scope="props">
                        <div class="option__desc">
                          <span class="option__name font-weight-bold">{{
                            props.option.name
                          }}</span>
                        </div>
                      </template>
                    </Multiselect>
                    <div v-if="submitted && !user_type_id" class="text-danger">
                      <span class="font-size-15 font-weight-normal"
                        >{{ $t("common.userType") }}
                        {{ $t("common.required") }}</span
                      >
                    </div>
                  </div>

                  <!-- first name  -->
                  <div
                    class="form-group m-d-gruop edit-group"
                    :class="{
                      'invalid-field':
                        submitted && $v.form.user.first_name.$error,
                    }"
                  >
                    <b-form-input
                      id="first_name"
                      type="text"
                      v-model="form.user.first_name"
                      required
                    />
                    <label for="first_name">{{ $t("common.firstName") }}</label>
                    <!-- <div
                      class="text-danger"
                      v-if="submitted && !$v.form.user.first_name.required"
                    >
                      <span class="font-size-15 font-weight-normal"
                        >First Name is required</span
                      >
                    </div> -->
                  </div>

                  <!-- last name  -->
                  <div
                    class="form-group m-d-gruop"
                    :class="{
                      'invalid-field':
                        submitted && $v.form.user.last_name.$error,
                    }"
                  >
                    <b-form-input
                      id="last_name"
                      type="text"
                      v-model="form.user.last_name"
                      required
                    />
                    <label for="last_name">{{ $t("common.lastName") }}</label>
                    <!-- <div
                      class="text-danger"
                      v-if="submitted && !$v.form.user.last_name.required"
                    >
                      <span class="font-size-15 font-weight-normal"
                        >Last Name is required</span
                      >
                    </div> -->
                  </div>

                  <!-- email  -->
                  <div class="form-group m-d-gruopp">
                    <b-form-input
                      id="email"
                      type="text"
                      v-model="form.user.email"
                    />
                    <label
                      :class="{
                        'no-value-field': !form.user.email,
                        'value-field': !!form.user.email,
                      }"
                      for="email"
                      >{{ $t("common.email") }}</label
                    >
                  </div>

                  <!-- phone  -->
                  <div
                    v-if="update && currentPhone"
                    class="current-phone d-flex align-items-center"
                  >
                    <p class="mb-0">{{ form.user.phone }}</p>
                    <a
                      @click="onChangeToUpdatePhone"
                      class="change-text ml-2"
                      >{{ $t("common.change") }}</a
                    >
                  </div>
                  <div class="phone-input-wrapper">
                    <VueCountryCode
                      :disabledFetchingCountry="false"
                      @onSelect="onSelectUserCountryCode"
                      :enabledCountryCode="true"
                      :preferredCountries="['GB', 'US', 'CN']"
                    />
                    <div
                      class="form-group m-d-gruopp"
                      :class="{
                        'invalid-field': submitted && $v.userPhone.$error,
                      }"
                    >
                      <b-form-input
                        id="phone"
                        v-model="userPhone"
                        type="phone"
                        @wheel="$event.target.blur()"
                      />
                      <label
                        :class="{
                          'no-value-field': !userPhone,
                          'value-field': !!userPhone,
                        }"
                        for="phone"
                        >{{ $t("common.phoneNumber") }}</label
                      >
                    </div>
                  </div>
                  <div
                    v-if="submitted && !$v.userPhone.numeric"
                    class="text-danger w-100"
                  >
                    <span>{{ $t("common.notes.phoneNumberOnlyDigits") }}</span>
                  </div>

                  <!-- RFID  -->
                  <div class="form-group m-d-gruopp">
                    <b-form-input
                      id="rfid"
                      v-model="form.user.rfid_number"
                      type="number"
                      @wheel="$event.target.blur()"
                    />
                    <label
                      :class="{
                        'no-value-field': !form.user.rfid_number,
                        'value-field': !!form.user.rfid_number,
                      }"
                      for="rfid"
                      >{{ $t("common.RFID") }}</label
                    >
                  </div>
                </div>
                <b-row
                  class="actions flex-row"
                  style="padding: 16px 0 0 0; margin: auto"
                >
                  <div
                    class="text-center flex-row justify-content-center w-100 form-btn flex-row"
                  >
                    <b-button
                      variant="primary"
                      type="submit"
                      pill
                      :disabled="getLoading"
                      class="text-center save-changes"
                    >
                      <i
                        v-if="getLoading"
                        class="bx bx-loader bx-spin font-size-16 align-middle mr-2"
                      ></i>
                      <span v-else>
                        {{ $t("common.saveChanges").toUpperCase() }}
                      </span>
                    </b-button>
                  </div>
                </b-row>
              </div>
            </b-form>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>

    <VpFormLayout>
      <template v-slot:content-header>
        <Breadcrumb
          v-if="getFromView"
          style="background-color: transparent"
          :items="items"
        />
        <PageHeader v-else :title="title" />
      </template>
      <template v-slot:content-body>
        <!-- grid -->
        <section class="dashboard-grid white-bg-sec">
          <div class="data-grrid">
            <div class="d-flex error-count" style="margin-bottom: 15px">
              <h5>{{ $t("integrations.importedWithErrors") }}</h5>
              <span>{{ getUsersWithErrsCount }}</span>
            </div>

            <p class="note" v-if="getUsersWithErrsCount > 0">
              <b> {{ $t("common.notes.note") }}:</b>
              {{ $t("integrations.errorNote") }}
            </p>

            <DxDataGrid
              v-show="!isLoading"
              id="int-gridContainer"
              :ref="dataGridRef"
              :data-source="dataStore"
              :remote-operations="true"
              :rtl-enabled="rtlEnabled"
              :showBorders="false"
              :columnAutoWidth="true"
              :allowColumnReordering="true"
              :allowColumnResizing="true"
              :rowAlternationEnabled="false"
              :showColumnLines="true"
              :showRowLines="true"
              :repaint-changes-only="true"
              :two-way-binding-enabled="true"
              :no-data-text="getUsersWithErrsCount ? 'No data' : ''"
              @row-updated="updateRow($event)"
              @content-ready="contentReady($event)"
              @editor-preparing="onEditorPreparing($event)"
              :class="{ 'no-content': getUsersWithErrsCount == 0 }"
            >
              <!-- <DxEditing :use-icons="true" :allow-updating="true" :allow-adding="false" :allow-deleting="false" mode="row" /> -->

              <DxPaging :page-size="10" :visible="getUsersWithErrsCount > 0" />
              <DxScrolling mode="standard" :scroll-by-content="rtlEnabled" :use-native="!rtlEnabled" />
              <DxPager
                :visible="getUsersWithErrsCount > 0"
                :allowed-page-sizes="[5, 10, 25, 50, 100, 'all']"
                :display-mode="'full'"
                :show-page-size-selector="true"
                :show-info="true"
                :show-navigation-buttons="true"
                :infoText="$t('common.page')"
              />

              <!-- <DxSelection mode="multiple"/> -->

              <DxFilterRow :visible="true" />
              <!-- <DxFilterRow :visible="true" :apply-filter="currentFilter"/> -->

              <DxHeaderFilter :visible="true" />

              <!-- <DxSearchPanel :visible="true" placeholder="Search..."/> -->

              <DxColumnChooser
                :enabled="true"
                mode="select"
                :title="$t('common.grid.columnChooser')"
              />

              <!-- <DxGrouping :context-menu-enabled="true"/>
          <DxGroupPanel :visible="true"/> -->

              <DxExport :enabled="true" :allow-export-selected-data="false" />

              <DxToolbar>
                <!-- <DxItem name="columnChooserButton" location="before" /> -->
                <DxItem location="before" template="columnButtonTemplate" />
                <DxItem template="exportButtonTemplate" location="before" />
                <DxItem template="clearAllTemplate" location="before" />
              </DxToolbar>

              <DxColumn
                data-field="first_name"
                :caption="$t('common.firstName')"
                :filter-operations="['contains']"
                :allow-header-filtering="false"
              />

              <DxColumn
                data-field="last_name"
                :caption="$t('common.lastName')"
                :filter-operations="['contains']"
                :allow-header-filtering="false"
              />

              <DxColumn
                data-field="email"
                :caption="$t('common.emailAddress')"
                :width="200"
                :filter-operations="['contains']"
                :allow-header-filtering="false"
              />

              <DxColumn
                data-field="phone"
                :caption="$t('common.phoneNumber')"
                :filter-operations="['contains']"
                :allow-header-filtering="false"
              />

              <DxColumn
                data-field="user_id"
                :caption="$t('common.id')"
                :filter-operations="['contains']"
                :allow-header-filtering="false"
              />

              <DxColumn
                data-field="rfid_number"
                :caption="$t('common.RFID')"
                :filter-operations="['contains']"
                :allow-header-filtering="false"
              />

              <DxColumn
                data-field="user_type"
                :caption="$t('common.userType')"
                :filter-operations="['contains']"
                :allow-filtering="false"
                :allow-header-filtering="true"
              >
                <DxHeaderFilter :data-source="userTypeHeaderFilter" />
              </DxColumn>

              <DxColumn
                :caption="$t('common.error')"
                cell-template="error-cell"
                :calculate-cell-value="getErrMsg"
                :allow-filtering="false"
                :allow-sorting="false"
              />

              <DxColumn
                :caption="$t('common.grid.actions')"
                cell-template="action-cell"
                :allow-filtering="false"
                :allow-exporting="false"
                :allow-editing="false"
              >
                <DxHeaderFilter :allow-search="false" />
              </DxColumn>

              <template #clearAllTemplate>
                <div
                  v-if="showClearAll"
                  class="clear-cols d-flex align-items-center"
                >
                  <div class="toolbar-custom-line"></div>
                  <Button
                    :text="$t('common.grid.clearFilters')"
                    @click="clearFilter"
                    styling-mode="outlined"
                    type="danger"
                    class="clear-CustomColums"
                  />
                </div>
              </template>

              <template #exportButtonTemplate>
                <DxDropDownButton
                  class="export-dropdown"
                  :items="buttonData"
                  :text="$t('common.grid.export')"
                  @item-click="onItemClick"
                />
              </template>

              <template #columnButtonTemplate>
                <button
                  class="custom-columns"
                  @click="dataGrid.showColumnChooser()"
                >
                  <span class="custom-text"
                    >{{ $t("common.grid.columns") }}
                  </span>

                  <span class="custom-icon">
                    <i class="dx-icon dx-icon-spindown dx-icon-right"></i>
                  </span>
                </button>
              </template>

              <template #error-cell="{ data }">
                <div>
                  <span
                    class="errors-value first"
                    v-for="(key, index) of data.data.requiredError"
                    :key="index"
                    >{{
                      key == "first_name"
                        ? $t("common.firstName")
                        : key == "last_name"
                        ? $t("common.lastName")
                        : key
                    }}
                    {{ $t("common.required") }}
                    {{
                      data.data.requiredError[index + 1] ||
                      (data.data.invalidError &&
                        data.data.invalidError.length > 0) ||
                      ((!data.data.invalidError ||
                        data.data.invalidError.length == 0) &&
                        data.data.userTypeError)
                        ? "/"
                        : ""
                    }}
                  </span>

                  <span
                    class="errors-value diffrent"
                    v-for="(key, index) of data.data.invalidError"
                    :key="index + data.data.ID"
                    >invalid {{ key }} {{ key == "email" ? "address" : "" }}
                    {{
                      data.data.invalidError[index + 1] ||
                      data.data.userTypeError
                        ? " / "
                        : ""
                    }}
                  </span>

                  <span
                    class="errors-value diffrent"
                    v-if="data.data.userTypeError"
                    >{{ $t("integrations.userAssigned") }}
                    {{ data.data.userTypeError }}.</span
                  >
                </div>
              </template>

              <!-- <template #userType-cell="{ data }">
              <div>
                <div v-for="(key, index) of data.data.userType" :key="index">
                  {{ key }}
                </div>
              </div>
            </template> -->

              <template #action-cell="{ data }">
                <div class="d-flex align-items-center text-center edit-btnn">
                  <b-button
                    class="top-page-btn"
                    variant="primary"
                    v-on:click="openEditUserModal(data.data)"
                    v-b-modal.add-edit-user
                  >
                    <span>{{ $t("common.edit") }}</span>
                  </b-button>
                </div>
              </template>
            </DxDataGrid>
          </div>
          <div
            class="table-extension"
            v-if="!isLoading && getUsersWithErrsCount == 0"
          >
            <h4 class="duplicates-solved">{{ $t("integrations.noErrs") }}</h4>
            <p class="sync-msg" v-if="!getFromView">
              {{ $t("integrations.press") }}<b>"{{ $t("common.next") }}"</b
              >{{ $t("integrations.toFinish") }}
            </p>
          </div>
          <div
            class="action-btns"
            v-if="!getFromView"
            style="padding-top: 64px; padding-bottom: 64px"
          >
            <button
              class="submit-btn btn btn-primary"
              size="md"
              @click="redirectUserToIntegrationSettings"
            >
              <span>{{ $t("common.back") }}</span>
            </button>

            <button
              class="submit-btn btn btn-primary"
              size="md"
              :disabled="nextLoading || getLoading || getUsersWithErrsCount > 0"
              @click="redirectUser"
            >
              <i
                v-if="nextLoading || getLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
              ></i>
              <span>{{ $t("common.next") }}</span>
            </button>
          </div>
        </section>
      </template>
    </VpFormLayout>
  </div>
</template>

<style lang="scss" scoped>
@import "@/design/user_form_modals.scss";

.table-extension {
  width: 100% !important;
  // height: 304px !important;
  background: white !important;
  text-align: center !important;
  // padding-top: 79px !important;
  h4.duplicates-solved {
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #495057;
    padding-bottom: 22px;
  }
  .sync-msg {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    color: #939393;
  }
}
.custom-columns {
  margin-inline-start: -11px !important;
}
.action-btns {
  // margin-top: 64px;
  // padding-bottom: 64px;
  .submit-btn {
    margin-inline-end: 15px !important;
  }
}

.spinner-border {
  color: #103f5e;
  border-width: 0.35em;
  width: 38px;
  height: 38px;
  margin-inline-end: 15px;
  border-right-color: #d9d9d9;
}
.edit-btnn {
  .top-page-btn {
    width: 75px !important;
    height: 27px !important;
    border-radius: 4px !important;
    margin-inline-end: 75px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;

    color: #ffffff;
  }
}
.errors-value {
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 19px !important;
  color: #f46a6a !important;
  padding-inline-start: 0 !important;
}
.header-content {
  width: 100%;
  background: white;
  padding-bottom: 1px;
  padding-top: 40px;
}
.error-count {
  h5 {
    font-weight: 900;
    font-size: 20px;
    line-height: 24px;
    color: #939393;
    opacity: 0.46;
    padding-inline-start: 4px !important;
  }
  span {
    width: 47px;
    height: 29px;
    text-align: center;
    background-color: #f46a6a !important;
    color: #ffffff;
    font-weight: 600;
    font-size: 16px;
    border-radius: 15.5 !important;
    margin-inline-start: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.note {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.25px;
  color: #939393;
  opacity: 0.8;
  padding-inline-start: 4px;
  // padding-top:15px;
}
.white-bg-sec {
  background-color: white;
  padding-inline-start: 36px;
  padding-top: 40px;
}

.change-text {
  text-decoration: underline !important;
  color: #50a5f1;
}
.delete-icon {
  font-size: 1.3rem;
  margin-inline-start: 8px;
  cursor: pointer;
}
.user-types-select {
  z-index: 1100;
}
.user-roles {
  z-index: 999;
}
p {
  display: block;
  color: #939393;
}
.header-close {
  font-size: 24px !important;
  font-weight: bold !important;
  background-color: transparent;
  border: none;
}

.header-close:active {
  outline: none;
}

h5.modal-title {
  width: 100%;
  text-align: center;
  font-size: 19px;
  font-weight: 700;
}

.error-count {
  h5 {
    color: #939393;
    font-weight: bold;
    font-size: 20px;
  }
  span {
    background-color: #f46a6a;
    color: white;
    padding-top: 2px !important;
    font-size: 16px;
    border-radius: 15.5px;
    margin-inline-start: 15px;
  }
}
</style>
<style lang="scss">
div#alreadyFixedErr___BV_modal_content_ {
  width: 579px !important;
  margin-top: 150px;
  border-radius: 26px !important;
  h3.signIn-out-header {
    color: #000;

    font-size: 17px;

    font-weight: 700;
    line-height: normal;
    margin-bottom: 40px;
  }
  h3.signIn-out-status {
    color: #787878;
    text-align: center;

    font-size: 16px;

    font-weight: 700;
    line-height: 155%;
    margin-bottom: 16px;
  }
  p.all-paragraphs {
    color: var(--939393, #939393);
    text-align: center;

    font-size: 20px;

    font-weight: 400;
    line-height: 175.5%; /* 35.1px */
    margin-bottom: 0px !important;
  }

  hr {
    margin-top: 40px !important;
    margin-bottom: 20px !important;
    border: 0;
    border-top: 1px solid #707070;
    opacity: 0.15;
  }
  .btn-container {
    display: flex;
    justify-content: center;
    button.confirmation-btn {
      width: 112px;
      height: 33px;
      border-radius: 16.5px;
      background: #103f5e;
      border: none;
      color: #fff;
      text-align: center;

      font-size: 16px;

      font-weight: 400;
      line-height: normal;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }
  }
}
div#int-gridContainer {
  .dx-datagrid-header-panel {
    padding-inline-start: 15px !important;
  }
}
div#add-edit-user___BV_modal_content_ {
  width: 491px !important;
  height: 633px !important;
  background: #ffffff;
  box-shadow: 0px 1px 40px 3px rgba(0, 0, 0, 0.05);
  border-radius: 26px;
  .userType {
    position: relative;
  }
  .selections-label {
    position: absolute;
    color: #103f5e;
    margin-top: 10px;
    margin-inline-end: 0;
    margin-bottom: 0;
    margin-inline-start: 20px;
    z-index: 100000;

    font-size: 12px;
    font-weight: 700;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-align: start;
  }
  .user-types-select {
    .multiselect--active {
      .multiselect__select:before {
        top: 10px;
      }
    }
  }
  input#userType {
    margin-top: 12px !important;
  }
  input#userType::placeholder {
    padding-top: 20px !important;
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: #787878;
  }
  .modal-header {
    align-items: center;
    background: white !important;
  }
  h5.modal-title {
    font-weight: 700;
    font-size: 17px;
    line-height: 20px;
    text-align: center;
    margin-bottom: 45px !important;
    margin-top: 8px;
    color: #000000;
  }
  label.intName {
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 17px !important;
    letter-spacing: 0.25px !important;

    color: rgba(96, 96, 96, 0.87) !important;

    opacity: 0.8 !important;
  }
  label.intName.itnName-type {
    font-weight: 700 !important;
    font-size: 12px !important;
    line-height: 17px !important;
    letter-spacing: 0.25px !important;
    color: #103f5e !important;
    opacity: 0.8 !important;
  }
  .personal-information .form-group {
    padding-top: 0 !important;
    border-top: none;
  }
  .phone-input-wrapper {
    display: grid;
    grid-template-columns: 27% 68%;
    grid-gap: 5%;
    height: 55px;
    margin-bottom: 15px;
    span.country-code {
      font-weight: 400 !important;
      font-size: 16px !important;
      line-height: 17px !important;

      letter-spacing: 0.25px;

      color: #000000 !important;
    }
    span.dropdown-arrow {
      color: #000000;
      font-size: 16px;
    }
    .vue-country-select {
      height: 55px;

      background: #f2f2f2;
      border-radius: 4px;
      border: none;
    }
    .custom-phone {
      font-weight: 400;
      font-size: 16px;
      line-height: 17px;

      padding-inline-start: 20px !important;
      letter-spacing: 0.25px;

      color: rgba(0, 0, 0, 0.87);

      opacity: 0.8;
      height: 55px;

      background: #f2f2f2;
      border-radius: 4px;
      border: none;
    }
    .user-types-select {
      width: 416px;
      height: 55px;
      background: #f2f2f2;
      border-radius: 4px;
    }
  }
  .save-changes {
    background: #103f5e;
    border-radius: 22px;
    width: 415px !important;
    height: 44px;
    margin-inline-end: 0 !important;
    span {
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;

      text-align: center;
      letter-spacing: 0.25px;

      color: rgba(255, 255, 255, 0.87);
    }
  }
  .multiselect__tags {
    height: 55px;
    background: #f2f2f2 !important;
    border-radius: 4px !important;
    margin-bottom: 14px !important;
    border: none !important;
    span.multiselect__single {
      height: 55px;
      padding: 0 !important;
      background: transparent !important;
      margin-top: 10px !important;
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      margin-inline-start: 10px;
      margin-top: 20px !important;
      letter-spacing: 0.25px;

      color: #787878;
    }

    .multiselect__input {
      background: transparent !important;
    }
  }
  .multiselect__select:before {
    position: relative;
    inset-inline-end: 0;
    top: 25px;
    // color: #999;
    /* margin-top: 4px; */
    border-color: #636161 transparent transparent;
    border-style: solid;
    border-width: 5px 5px 0;
    content: "";
  }
  .m-d-gruopp > input {
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;

    letter-spacing: 0.25px;

    color: rgba(0, 0, 0, 0.87);

    opacity: 0.8;
  }
}
.no-content {
  .dx-scrollable-scroll-content,
  .dx-scrollable-container {
    display: none !important;
  }
}
.dashboard-grid {
  border-start-start-radius: 6px !important;
  tbody {
    color: #495057;
  }
}
</style>
